<template>
    <div>
        <b-container fluid>

            <b-button @click="voltar()" variant="primary" class="mb-2">Voltar</b-button>

            <b-card :title="ficha.nome">
                <b-card-sub-title>
                    {{ficha.celular}} / {{ficha.fone}}
                    <p>
                        Alergias : {{ficha.alergias}}
                    </p>
                </b-card-sub-title>
                <b-card no-body class="mb-1" v-for="(atendimento, index) in ficha.atendimentos" :key="index">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block @click="toggleAccordion(atendimento.id)" variant="info">
                            {{atendimento.cz06_dtat}} - {{atendimento.cz08_nome}}
                        </b-button>
                    </b-card-header>
                    <b-collapse :id="atendimento.id" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <div v-if='atendimento.cz06_obs' >
                                <h4> Causa</h4>
                                <p> {{atendimento.cz06_obs}} </p>
                            </div>

                            <div v-if='atendimento.cz06_diagencaminhado'>
                                <h4> Diagnóstico Encaminhado</h4>
                                <p> {{atendimento.cz06_diagencaminhado}} </p>
                            </div>

                            <div v-if='atendimento.cz06_histmolatual'>
                                <h4> História Doença Atual</h4>
                                <p> {{atendimento.cz06_histmolatual}} </p>
                            </div>

                            <div v-if='atendimento.cz06_histmolpreg'>
                                <h4> História Doença Pregressa</h4>
                                <p> {{atendimento.cz06_histmolpreg}} </p>
                            </div>

                            <div v-if='atendimento.cz06_doencaconcomitante'>
                                <h4> Doenças Concomitantes</h4>
                                <p> {{atendimento.cz06_doencaconcomitante}} </p>
                            </div>

                            <div v-if='atendimento.cz06_histfarmaco'>
                                <h4> História Farmacológica</h4>
                                <p> {{atendimento.cz06_histfarmaco}} </p>
                            </div>

                            <div v-if='atendimento.cz06_histsocial'>
                                <h4> História Social</h4>
                                <p> {{atendimento.cz06_histsocial}} </p>
                            </div>

                            <div v-if='atendimento.cz06_exa'>
                                <h4> História</h4>
                                <p> {{atendimento.cz06_exa}} </p>
                            </div>

                            <div v-if='atendimento.cz06_exa1'>
                                <h4> Exame Fisico</h4>
                                <p> {{atendimento.cz06_exa1}} </p>
                            </div>

                            <div v-if='atendimento.cz06_testespeciais'>
                                <h4> Testes Especiais</h4>
                                <p> {{atendimento.cz06_testespeciais}} </p>
                            </div>

                            <div v-if='atendimento.cz06_goniometria'>
                                <h4> Goniometria</h4>
                                <p> {{atendimento.cz06_goniometria}} </p>
                            </div>

                            <div v-if='atendimento.cz06_diag'>
                                <h4> Diagnostico</h4>
                                <p> {{atendimento.cz06_diag}} </p>
                            </div>

                            <div v-if='atendimento.cz06_cons'>
                                <h4> Considerações</h4>
                                <p> {{atendimento.cz06_cons}} </p>
                            </div>

                            <div v-if='atendimento.procedimentos'>
                                <h4> Procedimentos</h4>
                                <p> {{atendimento.procedimentos}} </p>
                            </div>

                            <div v-if='atendimento.exames'>
                                <h4> Exames Solicitados</h4>
                                <p> {{atendimento.exames}} </p>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import PacienteFicha from '../services/PacienteFichaService'
import moment from 'moment'

export default {
  name: 'ficha',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created () {
    let id = this.$route.params.id
    this.id = id
    this.get()
  },
  data () {
    return {
      id: '',
      ficha: '',
      paciente: ''
    }
  },
  methods: {
    voltar () {
      this.$router.push({name: this.prevRoute.name})
    },
    toggleAccordion (id) {
      this.$root.$emit('bv::toggle::collapse', id)
    },
    get () {
      let pesquisa = {}
      const obj = JSON.parse(localStorage.usuarioMC)

      // pesquisa.id = this.id

      if (obj.empresa !== undefined) {
        pesquisa.empresa = JSON.stringify(obj.empresa)
      }
      if (obj.usuario.cz08_crem !== undefined) {
        pesquisa.crm = obj.usuario.cz08_crem
      }
      PacienteFicha.get(this.id, pesquisa).then((result) => {
        let atendimentos = result.atendimentos

        atendimentos.forEach((atendimento, index) => {
          atendimento.id = 'atendimento-' + index
          atendimento.cz06_dtat = moment(atendimento.cz06_dtat).format('DD/MM/YYYY')
        })

        result.atendimentos = atendimentos
        this.ficha = result
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/views/Ficha.vue